import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-cream py-28 px-16">
      <div className="max-w-[1300px] mx-auto">
        {/* Testimonial */}
        <div className="border-l-2 border-gold/50 pl-12 mb-24">
          <p className="text-[10px] tracking-[0.25em] text-gold uppercase font-sans mb-6">
            Client Voice
          </p>
          <blockquote className="font-serif text-charcoal text-3xl font-light leading-relaxed max-w-3xl mb-8">
            "하이반텍스의 불리온 자수는 우리 브랜드의 품격을 한층 높여주었습니다.
            장인의 손끝에서 탄생한 엠블럼은 단순한 제품을 넘어 예술 작품입니다."
          </blockquote>
          <div className="flex items-center gap-4">
            <span className="text-charcoal font-sans text-sm font-medium tracking-wide">
              김지현 대표
            </span>
            <span className="text-charcoal/30 text-xs font-sans">·</span>
            <span className="text-charcoal/40 text-xs font-sans tracking-wide">
              Premium Fashion Brand, Seoul
            </span>
          </div>
        </div>

        {/* CTA banner */}
        <div
          className="relative overflow-hidden bg-[#1C1C1C] p-16 flex items-center justify-between"
        >
          {/* Background glow */}
          <div
            className="absolute right-0 top-0 bottom-0 w-1/2 pointer-events-none"
            style={{
              backgroundImage:
                'radial-gradient(ellipse 80% 100% at 100% 50%, rgba(201,169,97,0.08) 0%, transparent 70%)',
            }}
          />
          {/* Corner decor */}
          <div className="absolute top-6 left-6 w-10 h-10 border-l border-t border-gold/25" />
          <div className="absolute bottom-6 right-6 w-10 h-10 border-r border-b border-gold/25" />

          <div className="relative z-10">
            <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans mb-4">
              Get in Touch
            </p>
            <h3 className="font-serif text-cream text-4xl font-light leading-tight">
              맞춤 제작 상담<br />
              <em className="not-italic text-gold">지금 시작하세요</em>
            </h3>
          </div>

          <div className="relative z-10 flex items-center gap-4">
            <Link
              to="/contact"
              className="bg-gold text-charcoal text-[10px] tracking-[0.2em] uppercase px-12 py-4 hover:bg-gold-dark transition-all duration-300 font-sans font-medium whitespace-nowrap cursor-pointer"
            >
              상담 신청하기
            </Link>
            <Link
              to="/shopping"
              className="border border-cream/20 text-cream/60 text-[10px] tracking-[0.2em] uppercase px-12 py-4 hover:border-gold/50 hover:text-gold transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
            >
              제품 보기
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
